import React, { useState, useEffect } from 'react';
import { FormControlLabel, RadioGroup, Radio, Typography  } from "@material-ui/core";
import RadioButtonUncheckedIcon from '@material-ui/icons/RadioButtonUnchecked';
import CheckCircleIcon from '@material-ui/icons/CheckCircle';
import baseUrl from '../../config/config';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles(theme => ({
    customTypography: {
      fontFamily: 'FTPolar-Light',
    },
  }));

export default function SellHome(props) {
    const classes = useStyles();
    const [sell, setSell] = useState([])
    function StyledRadio(props) {
        const useStyles = makeStyles({
            root: {
                '&:hover': {
                    backgroundColor: 'transparent',
                },
            }
        })
        const classes = useStyles();
        return (
            <Radio
                className={classes.root}
                disableripple="true"
                color="default"
                checkedIcon={<CheckCircleIcon className="checkedIcon" />}
                icon={<RadioButtonUncheckedIcon />}
                {...props}
            />
        );
    }

    useEffect(()=>{
        if(props?.partner?.url_path === "c2"){
            const h2Tags = document.querySelectorAll('h2');
            const h4Tags = document.querySelectorAll('h4');
            const h6Tags = document.querySelectorAll('h6');
            const spanTags = document.querySelectorAll('span');
            const a = document.querySelectorAll('a');
              h2Tags.forEach(h2 => {
                h2.classList.add('ftpolar-semibold');
              });
              h4Tags.forEach(h4 => {
                h4.classList.add('ftpolar-semibold');
              });
              h6Tags.forEach(h6 => {
                h6.classList.add('ftpolar-semibold');
              });
              spanTags.forEach(span => {
                span.classList.add('ftpolar-light');
              });
              a.forEach(a => {
                a.classList.add('ftpolar-light');
              });
        }
        },[props.pageNumber,props.submitResponse])

    useEffect(() => {
		props.handleNext("readytosell")
	}, [])

    useEffect(() => {
        fetch(`${baseUrl.baseUrlCP}get_ready_to_sell/`,
            {
                headers: {
                    "Authorization": `${process.env.REACT_APP_API_KEY}`,
'Accept-Encoding': 'gzip, deflate',
                }
            })
            .then(async response => {
                const result = await response.json()
                if (response.status === 201 || response.status === 200) {
                    setSell(result)
                }
                else if (response.status === 403) {
                }
            }
            );
    }, [])

    return (
        <div className="form-question">
            <div className="form-content" id="ready_to_sell">
                <h4 className="form-content-heading m-0">
                    When would you be ready to sell your home?
                </h4>
                <div className="pt-2 check-box form-content-field">
                    <div className="py-2">
                        <RadioGroup name="property_ready_to_sell_id" value={props.values.property_ready_to_sell_id} onChange={props.handleChange} >
                            {sell && sell.map((sell, index) => (
                                <FormControlLabel
                                    key={sell.property_ready_to_sell_id}
                                    label={
                                        <Typography
                                          className={props?.partner?.url_path === "c2" ? classes.customTypography : ""}
                                          variant="body1"
                                        >
                                          {sell.ready_to_sell}
                                        </Typography>
                                    }
                                    control={<StyledRadio />}
                                    value={sell.property_ready_to_sell_id.toString()}
                                />
                            ))}
                        </RadioGroup>
                    </div>
                </div>
            </div>
        </div>
    )
}
